import type { ReactNode } from "react";

/**
 * The bypass notice. The member and partner test suites pin this text verbatim.
 * `000000` mirrors the server's fixed accepted code (`verify.BYPASS_OTP_CODE`).
 */
export const BYPASS_SMS_OTP_BANNER_TEXT =
  "BYPASS_SMS_OTP feature flag is turned on. Use code 000000";

interface BypassOtpBannerProps {
  /**
   * The `bypassSmsOtp` flag from the response that sent (or skipped) the OTP.
   * The banner renders only when it is true.
   */
  bypassSmsOtp: boolean;
}

/**
 * Warning on each member and partner screen that awaits an SMS OTP while the bypass applies.
 *
 * With the super-admin BYPASS_SMS_OTP feature flag on, no real SMS goes out and
 * every verify accepts the fixed code. The server sends `bypassSmsOtp: true`
 * only when the bypass applies (never in prod), so the banner follows the flag
 * alone. It is a persistent notice rather than a transient error, hence
 * `role="status"`.
 */
export function BypassOtpBanner({ bypassSmsOtp }: BypassOtpBannerProps): ReactNode {
  if (!bypassSmsOtp) return null;
  return (
    <p
      role="status"
      className="rounded-md border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-800"
    >
      {BYPASS_SMS_OTP_BANNER_TEXT}
    </p>
  );
}
